import { useLayoutEffect, useRef } from 'react';

import { Box } from 'ui/Layout';

import { Sankey } from '../../generated-api';

type Props = {
  diagram: Sankey;
  isSelected: boolean;
  onClick: () => void;
  onDoubleClick: () => void;
};

// TODO: Wrap this component with RadioCard: https://www.chakra-ui.com/docs/components/radio-card
const DiagramCard: React.FC<Props> = ({
  diagram,
  isSelected,
  onClick,
  onDoubleClick,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const svgElement = ref.current?.getElementsByTagName('svg')[0];
    if (svgElement) {
      svgElement.setAttribute(
        'viewBox',
        `0 0 ${svgElement.getAttribute('width')} ${svgElement.getAttribute(
          'height'
        )}`
      );
      svgElement.style.width = '100%';
      svgElement.style.height = 'auto';
    }
  }, [ref.current]);

  return (
    <Box
      border="2px solid"
      borderColor={isSelected ? 'green.600' : 'gray.200'}
      cursor="pointer"
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      <Box
        dangerouslySetInnerHTML={{
          __html: diagram.svg_representation ?? '<svg></svg>',
        }}
        pointerEvents="none"
        ref={ref}
      />
    </Box>
  );
};

export default DiagramCard;
